import React, { useContext } from 'react';

import PerfectScrollbar from 'react-perfect-scrollbar';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CmtVertical from '../../../../../@coremat/CmtNavigation/Vertical';
import { AuthContext } from '../../../context/AuthContext';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import IntlMessages from '../../../../utils/IntlMessages';
import { Home, PostAdd } from '@material-ui/icons';
import LanguageIcon from '@material-ui/icons/Language';

import PublicIcon from '@material-ui/icons/Public';

import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

import AccountTreeIcon from '@material-ui/icons/AccountTree';

import LocalAtmIcon from '@material-ui/icons/LocalAtm';

import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';

import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';

import ExploreIcon from '@material-ui/icons/Explore';

import ApartmentIcon from '@material-ui/icons/Apartment';

import CategoryIcon from '@material-ui/icons/Category';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import LabelIcon from '@material-ui/icons/Label';
import ViewListIcon from '@material-ui/icons/ViewList';
import EventNoteIcon from '@material-ui/icons/EventNote';
import CachedIcon from '@material-ui/icons/Cached';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PaymentIcon from '@material-ui/icons/Payment';

const useStyles = makeStyles(() => ({
  perfectScrollbarSidebar: {
    height: '100%',
    transition: 'all 0.3s ease',
    '.Cmt-sidebar-fixed &, .Cmt-Drawer-container &': {
      height: 'calc(100% - 167px)',
    },
    '.Cmt-modernLayout &': {
      height: 'calc(100% - 72px)',
    },
    '.Cmt-miniLayout &': {
      height: 'calc(100% - 91px)',
    },
    '.Cmt-miniLayout .Cmt-sidebar-content:hover &': {
      height: 'calc(100% - 167px)',
    },
  },
}));

const navigationMenus = [
  {
    name: 'Dashboard',
    type: 'item',
    icon: <Home />,
    link: '/dashboard',
  },

  {
    name: 'Country',
    type: 'item',
    icon: <PublicIcon />,
    link: '/country-list',
  },
  // {
  //   name: 'CashPickUp',
  //   type: 'item',
  //   icon: <AttachMoneyIcon />,
  //   link: '/cash-pickup-list',
  // },

  {
    name: 'Bank',
    type: 'collapse',
    icon: <AccountBalanceIcon />,
    children: [
      {
        name: 'Bank List',
        type: 'item',
        icon: <AccountBalanceIcon />,
        link: '/bank-list',
      },
      {
        name: 'Branch',
        type: 'item',
        icon: <AccountTreeIcon />,
        link: '/branch',
      },
    ],
  },

  // {
  //   name: 'Bank Beneficiary',
  //   type: 'item',
  //   icon: <LocalAtmIcon />,
  //   link: '/bank-beneficiary-list',
  // },

  {
    name: 'MFS',
    type: 'item',
    icon: <AccountBalanceWalletIcon />,
    link: '/mfs-list',
  },

  // {
  //   name: 'MFS Beneficiary',
  //   type: 'item',
  //   icon: <PersonOutlineIcon />,
  //   link: '/mfs-beneficiary-list',
  // },
  {
    name: 'Country MFS Mapper',
    type: 'item',
    icon: <ExploreIcon />,
    link: '/country-mfs-mapper-list',
  },
  {
    name: 'Country Bank Mapper',
    type: 'item',
    icon: <ApartmentIcon />,
    link: '/country-bank-mapper-list',
  },
  {
    name: 'KYC',
    type: 'collapse',
    icon: <RecentActorsIcon />,
    children: [
      {
        name: 'Document',
        type: 'item',
        icon: <FileCopyIcon />,
        link: '/document',
      },
      {
        name: 'KYC Request',
        type: 'item',
        icon: <AccountBalanceIcon />,
        link: '/kyc-list',
      },
    ],
  },

  {
    name: 'Tier Management',
    type: 'collapse',
    icon: <LabelIcon />,
    children: [
      {
        name: 'Tier Upgrade Request',
        type: 'item',
        icon: <EventNoteIcon />,
        link: '/tier-request-upgrade',
      },
      {
        name: 'List of Tier',
        type: 'item',
        icon: <ViewListIcon />,
        link: '/tier',
      },
      {
        name: 'Requirements',
        type: 'item',
        icon: <EventNoteIcon />,
        link: '/requirements',
      },
      {
        name: 'List of Limit',
        type: 'item',
        icon: <ViewListIcon />,
        link: '/limit',
      },
    ],
  },
  {
    name: 'Agent',
    type: 'collapse',
    icon: <SupervisorAccountIcon />,
    children: [
      {
        name: 'Agent List',
        type: 'item',
        icon: <ViewListIcon />,
        link: '/agent',
      },
      {
        name: 'Agent Request',
        type: 'item',
        icon: <EventNoteIcon />,
        link: '/agent-request',
      },
    ],
  },
  {
    name: 'Currency Conversion',
    type: 'collapse',
    icon: <CachedIcon />,
    children: [
      {
        name: 'Conversion Rate',
        type: 'item',
        icon: <EventNoteIcon />,
        link: '/all-base-currency',
      },
      {
        name: 'Base Rate',
        type: 'item',
        icon: <ViewListIcon />,
        link: '/base-currency-conversion-rate',
      },
    ],
  },
  {
    name: 'Country Documents',
    type: 'collapse',
    icon: <AssignmentIcon />,
    children: [
      {
        name: 'Document List',
        type: 'item',
        icon: <ViewListIcon />,
        link: '/country-documents',
      },
      {
        name: 'Document Create',
        type: 'item',
        icon: <ViewListIcon />,
        link: '/country-documents-create',
      },
    ],
  },
  {
    name: 'Transaction',
    type: 'collapse',
    icon: <PaymentIcon />,
    children: [
      {
        name: 'Transfers',
        type: 'item',
        icon: <ViewListIcon />,
        link: '/admin/transfers',
      },
      {
        name: 'Transaction Rate',
        type: 'item',
        icon: <ViewListIcon />,
        link: '/transaction-charge-policy',
      },
      {
        name: 'Transaction Methods',
        type: 'item',
        icon: <ViewListIcon />,
        link: '/transaction-method',
      },
    ],
  },
  {
    name: 'FAQ',
    type: 'collapse',
    icon: <HelpOutlineIcon />,
    children: [
      {
        name: 'Category',
        type: 'item',
        icon: <CategoryIcon />,
        link: '/category',
      },
      {
        name: 'Question',
        type: 'item',
        icon: <LiveHelpIcon />,
        link: '/question',
      },
    ],
  },
  {
    name: 'Account Settings',
    type: 'item',
    icon: <SettingsIcon />,
    link: '/account-settings',
  },
  {
    name: 'Logout',
    type: 'item',
    icon: <ExitToAppIcon />,
  },
];

const SideBar = () => {
  const classes = useStyles();
  const { logout } = useContext(AuthContext);

  const menuItems = navigationMenus.map(item =>
    item.name === 'Logout' ? { ...item, onClick: logout } : item
  );

  return (
    <PerfectScrollbar className={classes.perfectScrollbarSidebar}>
      <CmtVertical menuItems={menuItems} />
    </PerfectScrollbar>
  );
};

export default SideBar;
